// test664
(664 && 0);
